import React, { useContext, useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Spinner,
  InputGroup,
  Button,
  Form,
} from "react-bootstrap";
import "../../../assets/css/user/deals/allDeals.css";
import SimpleBanner from "../../../components/user/general/SimpleBanner";
import Footer from "../../../components/user/footer/Footer";

import axios from "axios";
import AppContext from "../../../context/AppContext";
import TpDealCard from "../../../components/user/card/dealCard/TpDealCard";
import {
  FaBolt,
  FaChartLine,
  FaFilter,
  FaFire,
  FaSearch,
} from "react-icons/fa";
import MarqueeBanner from "../../../components/user/Marqueebanner/Marqueebanner";
import MyNavbar from "../../../components/user/navbar/Navbar";

const PAKISTAN_CITIES = [
  "Karachi",
  "Lahore",
  "Islamabad",
  "Rawalpindi",
  "Faisalabad",
  "Multan",
  "Gujranwala",
  "Peshawar",
  "Quetta",
  "Sialkot",
  "Bahawalpur",
  "Sargodha",
  "Sukkur",
  "Jhang",
  "Sheikhupura",
  "Gujrat",
  "Mardan",
  "Kasur",
  "Rahim Yar Khan",
  "Sahiwal",
  "Okara",
  "Wah Cantt",
  "Dera Ghazi Khan",
  "Mirpur",
  "Nawabshah",
  "Mingora",
  "Chiniot",
  "Kamoke",
  "Hafizabad",
  "Jacobabad",
  "Muzaffarabad",
  "Abbottabad",
  "Kohat",
  "Dera Ismail Khan",
  "Turbat",
  "Gwadar",
  "Khuzdar",
  "Larkana",
  "Shikarpur",
  "Bannu",
  "Nowshera",
  "Swabi",
  "Attock",
  "Jhelum",
  "Mandi Bahauddin",
  "Taxila",
  "Murree",
];

// ─── Deals Page ─────────────────────────────────────────────────────────────
const Deals = () => {
  const [activeFilter, setActiveFilter] = useState("all");
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState(null);
  const [activeCategory, setActiveCategory] = useState(null);
  const [activeLocation, setActiveLocation] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const DEALS_PER_PAGE = 8;

  const [tpdeals, setTpdeals] = useState([]);
  const [categories, setCategories] = useState([]);
  const { baseUrl, selectedCategory, selectedCategoryTagline } =
    useContext(AppContext);
  const viewAllDeals = () => {
    axios
      .get(`${baseUrl}/customer/deals/viewAllDeals`)
      .then((response) => {
        console.log("Deals", response.data.deals);

        setTpdeals(response.data.deals);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  // ---------------- FETCH CATEGORIES ----------------
  // const getAllCategories = () => {
  //   axios
  //     .post(`${baseUrl}/shop/tpcategory/viewAllUploadedCategories`)
  //     .then((res) => setCategories(res.data.categoryRecords))
  //     .catch((err) => console.error(err));
  // };
  const viewAllCategories = () => {
  axios
    .get(`${baseUrl}/customer/tpcategory/viewAllCategories`)
    .then((response) => {
      console.log("Categories Response:", response.data);

      if (response.data.success) {
        console.log(
          "Categories:",
          response.data.categoryRecords
        );

        setCategories(response.data.categoryRecords);
      }
    })
    .catch((error) => {
      console.log("Category Error:", error.response?.data || error);
    });
};
  useEffect(() => {
    viewAllDeals();
    viewAllCategories();
  }, []);
  useEffect(() => {
    console.log("Deals State:", tpdeals);
  }, [tpdeals]);

  useEffect(() => {
    console.log("Categories State:", categories);
  }, [categories]);

  const filteredDeals = tpdeals.filter((deal) => {
    // Deal Type Filter
    const matchType =
      activeFilter === "all" ? true : deal.deal_type === activeFilter;

    // Category Filter
    const matchCategory =
      activeCategory === null
        ? true
        : deal.tpcategory?.categoryName === activeCategory;

    // Location Filter
    const matchLocation =
      activeLocation === null
        ? true
        : deal.deal_location?.toLowerCase() === activeLocation.toLowerCase();

    // Search Filter
    const matchSearch =
      deal.deal_title?.toLowerCase().includes(search.toLowerCase()) ||
      deal.tpshop?.shopname?.toLowerCase().includes(search.toLowerCase());

    return matchType && matchCategory && matchLocation && matchSearch;
  });

  return (
    <div>
      {/* <div className="all-deals-page"> */}
      <MarqueeBanner />
      <MyNavbar />

      <SimpleBanner
        // path={"Home > All Deals"}
        title="All Deals"
        subtitle=" Discover amazing deals from verified sellers."
        breadcrumbs={[
          { label: "Home", href: "/" },
          { label: "all deals", href: "/all deals" },
          //   { label: "wishlist Details", current: true },
        ]}
      />
      {/* ── Sticky Header ─────────────────────────────────── */}

      {!tpdeals ? (
        <Spinner />
      ) : (
        <>
          <div className="all-deals-header">
            <Container>
              {/* Title + Search + Filters Row */}
              <h1 className="all-deals-header__title">All Deals</h1>

              <p className="all-deals-header__subtitle">
                Discover amazing deals from verified sellers
              </p>

              <Row className="align-items-center g-3 mt-3">
                <Col lg={8}>
                  <Form.Control
                    type="text"
                    placeholder="Search deals..."
                    className="search-input"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </Col>

                <Col lg={4}>
                  <div className="filter-buttons">
                    <Button
                      className={`filter-btn ${activeFilter === "all" ? "active-btn" : ""}`}
                      onClick={() => setActiveFilter("all")}
                    >
                      All
                    </Button>

                    <Button
                      className={`filter-btn ${
                        activeFilter === "Hot Deals" ? "active-btn" : ""
                      }`}
                      onClick={() => setActiveFilter("Hot Deals")}
                    >
                      Hot
                    </Button>

                    <Button
                      className={`filter-btn ${
                        activeFilter === "Instant Deals" ? "active-btn" : ""
                      }`}
                      onClick={() => setActiveFilter("Instant Deals")}
                    >
                      Instant
                    </Button>

                    <Button
                      className={`filter-btn ${
                        activeFilter === "Trending Deals" ? "active-btn" : ""
                      }`}
                      onClick={() => setActiveFilter("Trending Deals")}
                    >
                      Trending
                    </Button>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>

          {/* ── Category Tabs ──────────────────────────────────── */}
          {/* ── Filters ──────────────────────────────────── */}
          <div className="all-deals-categories">
            <Container>
              <div className="filter-section">
                {/* Category */}
                <div className="filter-group">
                  <label className="filter-label">Category</label>

                  <div className="category-tabs">
                    <button
                      className={`category-tab ${
                        activeCategory === null ? "active" : ""
                      }`}
                      onClick={() => setActiveCategory(null)}
                    >
                      All
                    </button>

                    {categories.map((cat) => (
                      <button
                        key={cat.id}
                        className={`category-tab ${
                          activeCategory === cat.categoryName ? "active" : ""
                        }`}
                        onClick={() => setActiveCategory(cat.categoryName)}
                      >
                        {cat.categoryName}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Location */}
                <div className="location-filter-group">
                  <select
                    className="location-select"
                    value={activeLocation || ""}
                    onChange={(e) => setActiveLocation(e.target.value || null)}
                  >
                    <option value="">All Pakistan</option>

                    {PAKISTAN_CITIES.map((city) => (
                      <option key={city} value={city}>
                        {city}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </Container>
          </div>

          {/* ── Main Content ──────────────────────────────────── */}
          <div className="all-deals-content">
            <Container>
              {/* Results info */}
              {/* <div className="all-deals-results-bar">
                <select className="sort-select" defaultValue="featured">
                  <option value="featured">Sort: Featured</option>
                  <option value="price-asc">Price: Low to High</option>
                  <option value="price-desc">Price: High to Low</option>
                  <option value="rating">Highest Rated</option>
                  <option value="discount">Most Discount</option>
                </select>
              </div> */}
              {/* Cards Grid */}
              {filteredDeals.length > 0 ? (
                <Row className="g-3 g-md-4 all-deals-grid">
                  {filteredDeals.map((deal) => (
                    <TpDealCard key={deal.id} deal={deal} />
                  ))}
                </Row>
              ) : (
                <div className="all-deals-empty">
                  <div className="all-deals-empty__icon"></div>

                  <h3>Deals loading....</h3>

                  <p></p>
                </div>
              )}{" "}
            </Container>
          </div>
        </>
      )}
      <Footer />
    </div>
  );
};

export default Deals;